import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ShopProvider } from "@/lib/shop";
import { initPixels } from "@/lib/track";
import { loadKlaviyo } from "@/lib/klaviyo";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { CartDrawer } from "@/components/site/Cart";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductPage from "@/pages/ProductPage";
import About from "@/pages/About";
import Support from "@/pages/Support";
import ThankYou from "@/pages/ThankYou";
import ReviewPage from "@/pages/ReviewPage";
import Admin from "@/pages/Admin";
import Quiz from "@/pages/Quiz";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function App() {
  useEffect(() => { initPixels(); loadKlaviyo(); }, []);
  return (
    <div className="grain min-h-screen bg-[#050505]">
      <BrowserRouter>
        <ShopProvider>
          <SmoothScroll />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/support" element={<Support />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/review" element={<ReviewPage />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <CartDrawer />
          <Toaster theme="dark" position="bottom-center" />
        </ShopProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
